<template>
  <div>
    <div v-show="isMain">
    <div class="white-background list-top-margin">
      <!-- 面包屑导航 -->
      <div class="page-top">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>基础数据</el-breadcrumb-item>
          <el-breadcrumb-item>
            <span style="color:#000;font-weight:bold;">工艺路线</span>
          </el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <!-- 搜索筛选 -->
      <el-form :model="form" class="user-search" label-width="110px" size="small">
        <el-row>
          <el-col :span="8">
            <el-form-item label="工艺路线编号">
              <el-input size="small" v-model="form.technologyCode" placeholder="请输入工艺路线编号" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="工艺路线名称" >
              <el-input size="small" v-model="form.technologyName" placeholder="请输入工艺路线名称" clearable></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="2" class="text-align-right">
            <el-button size="small" type="primary" icon="el-icon-search" @click="search">查询</el-button>
          </el-col>
        </el-row>

      </el-form>
    </div>

    <div class="white-background">
        <el-row class="tbl-btn">
          <el-col :span="12" class="tbl-btn-left">
            <el-button size="small" type="primary" icon="el-icon-plus" @click="createProduct">创建工艺路线</el-button>
            <el-dropdown class="left-default-margin right-default-margin" @command="handleCommand" trigger="click">
              <el-button type="primary" size="small" plain icon="el-icon-s-operation">批量操作</el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="delete"><i class="el-icon-delete"></i>批量删除</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-button size="small" type="primary" plain icon="el-icon-download" @click="templateDownload">模板下载</el-button>
            <el-button size="small" type="success" plain icon="el-icon-upload2" @click="importData">导入</el-button>
            <el-button size="small" type="success" plain icon="el-icon-s-promotion" @click="exportExcelNew">导出</el-button>


            <el-upload  ref="workReportImp" name="workReportImp" :action="action()" :on-change="
                (file, fileList) => {
                handleChange(file, fileList);
                }
            "
              :auto-upload="false" :show-file-list="false" accept=".xlsx" v-show="false">

            </el-upload>
            <!-- <el-button size="small" type="primary" plain icon="el-icon-download">导入</el-button>
            <el-button size="small" type="primary" plain icon="el-icon-upload2">导出</el-button>
            <el-button type="text" icon="el-icon-s-data" @click="viewImportLog">查看导入日志</el-button> -->
          </el-col>
          <!-- <el-col :span="12" class="tbl-btn-right">
            <el-button type="default" size="small" icon="el-icon-s-operation">列配置</el-button>
          </el-col> -->
        </el-row>
        <!--列表-->
        <el-table
          ref="tableData"
          size="small"
          :data="listData"
          highlight-current-row
          v-loading="loading"
          stripe
          border
          :header-cell-style="_headerStyle"
          element-loading-text="加载中"
          style="width: 100%;"
          row-key="_id"
          @selection-change="handleTblSelectionChange"
        >
          <el-table-column align="left" type="selection" width="60" :reserve-selection="true" ></el-table-column>
          <el-table-column align="left" type="index" width="50" label="序号"></el-table-column>
          <el-table-column sortable prop="technologyCode" label="工艺路线编号" width="200">
            <template slot-scope="scope">
              <el-tooltip :content="scope.row.technologyCode" placement="top">
                <span class="txt-overflow">{{scope.row.technologyCode}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="工艺路线名称" width="200">
            <template slot-scope="scope">
              <el-tooltip :content="scope.row.technologyName" placement="top">
                <span class="txt-overflow">{{scope.row.technologyName}}</span>
              </el-tooltip>
            </template>
          </el-table-column>

          <el-table-column label="工序/工艺路线列表">
            <template slot-scope="scope">
              <el-tooltip :content="formatProcess(scope.row.processList)" placement="top">
                <span class="txt-overflow">{{formatProcess(scope.row.processList)}}</span>
              </el-tooltip>
            </template>
          </el-table-column>

          <el-table-column align="left" label="操作" width="190" fixed="right">
            <template slot-scope="scope">
              <el-tooltip content="编辑">
                <el-button
                  type="primary"
                  size="mini"
                  icon="el-icon-edit"
                  circle
                  @click="handleEdit(scope.$index, scope.row)"
                ></el-button>
              </el-tooltip>
              <!-- <el-tooltip content="复制">
                <el-button
                  type="primary"
                  size="mini"
                  icon="el-icon-printer"
                  circle
                  @click="handleEdit(scope.$index, scope.row)"
                ></el-button>
              </el-tooltip> -->

              <el-tooltip content="删除">
                <el-button
                  size="mini"
                  type="danger"
                  icon="el-icon-delete"
                  circle
                  @click="handleDelete(scope.$index, scope.row)"
                ></el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather" class="tbl-pagination"></Pagination>
      </div>
      </div>
      <ImportLog v-show="!isMain" :menuName="menuName" @goBack="goBack"></ImportLog>
      <div v-if="createProductPanVisible" >
        <CreateProcessRouting  @done="productSave" :userData="userData" :mode="mode" :editRow="editRow"></CreateProcessRouting>
      </div>
  </div>
</template>
<script>

import { technologyGetList,technologyDelete ,technologyBatchDelete} from '@/api/basicData'
import {processRouteBatchImp} from '@/api/business';
import Pagination from "@/components/Pagination";
import ImportLog from "@/components/importLog";
import CreateProcessRouting from '@/views/basicData/processRouting/createProcessRouting';
import {exportDataToExcel,transfer} from '@/utils/util';

export default {
  name: "ProcessRouting",
  components:{
      Pagination,
      CreateProcessRouting,
      ImportLog
  },
  data() {
    return {
      form: {},
      listData: [],
      loading: false,
      isBatchPrint: false,
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      createProductPanVisible:false,
      isMain:true,
      menuName:{
        first:'基础数据',
        second:'工艺路线',
        three:'导入日志',
      },
      userData:{},
      mode:'',
      editRow:{},
      tblSelectionList:[]


    };
  },
  created() {
    var userData = window.localStorage.getItem('userdata')
    if(userData){
      this.userData = JSON.parse(userData)
    }
    this.getdata()
  },
  methods: {
      //导出数据前对数据处理，变为想要的格式。
      filterTableData(data) {
      data.forEach((item) => {
       item.processList = item.processList?this.formatProcess(item.processList):'';

      });
      return data;
    },
    exportExcelNew(){
      if(this.tblSelectionList == null || this.tblSelectionList.length == 0){
        this.exportData();

        return;
      }
      const header = [
        '工艺路线编号',
        '工艺路线名称',
        '工序/工艺路线列表',

      ];

      const filterVal = [
        'technologyCode',
        'technologyName',
        'processList',
      ];
      let filterData =this.filterTableData( JSON.parse(JSON.stringify(this.tblSelectionList)));
      let data = filterData.map(v => filterVal.map(j => v[j]));
      exportDataToExcel(data,header,"工艺路线清册"+ Date.now());
    },
    exportData(){
      var params = {
        condition: {
          factoryId: this.userData.factoryId,
          technologyCode: this.form.technologyCode,
          technologyName: this.form.technologyName,
        },
        tableName:'工艺路线',
        collection:'technology',
      }

      var x = new XMLHttpRequest();
      var self = this;
      let url = this.$devEnv.API_ROOT + '/api/exportExcel';
      x.open("POST", url, true);
      x.responseType = 'blob';
      x.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
      x.onload=function(e) {
          if (x.readyState === x.DONE) {
              if (x.status === 200) {
                  //会创建一个 DOMString，其中包含一个表示参数中给出的对象的URL。这个 URL 的生命周期和创建它的窗口中的 document 绑定。这个新的URL 对象表示指定的 File 对象或 Blob 对象。
                  var url = window.URL.createObjectURL(x.response)
                  var a = document.createElement('a');
                  a.href = url
                  a.download = "工艺路线清册.xlsx";
                  a.click()
              }else {
                  self.$message({
                      type: 'error',
                      message: '下载失败',
                  });
              }
          }else {
              self.$message({
                  type: 'error',
                  message: '下载失败',
              });
          }
      }
      x.send(JSON.stringify(params));

    },
    handleChange(file, fileList){
        let data = new FormData();

        data.append("file", file.raw);
        data.append("factoryId ", this.userData.factoryId);
        data.append("creater",this.userData.name + "(" + this.userData.account + ")");
        processRouteBatchImp(data).then(res=>{
          this.getdata();

        });

    },
    action(){
      return this.$devEnv.API_ROOT + `/technology/importData`;
    },
    templateDownload(){
      var x = new XMLHttpRequest();
      var self = this;
      let url = this.$devEnv.API_ROOT + '/technology/downloadTemplate';
      x.open("GET", url, true);
      x.responseType = 'blob';
      x.onload=function(e) {
          if (x.readyState === x.DONE) {
              if (x.status === 200) {
                  //会创建一个 DOMString，其中包含一个表示参数中给出的对象的URL。这个 URL 的生命周期和创建它的窗口中的 document 绑定。这个新的URL 对象表示指定的 File 对象或 Blob 对象。
                  var url = window.URL.createObjectURL(x.response)
                  var a = document.createElement('a');
                  a.href = url
                  a.download = "工艺路线导入模板.xlsx";
                  a.click()
              }else {
                  self.$message({
                      type: 'error',
                      message: '下载失败',
                  });
              }
          }else {
              self.$message({
                  type: 'error',
                  message: '下载失败',
              });
          }
      }
      x.send();
    },
    importData(){
      this.$refs["workReportImp"].$refs['upload-inner'].handleClick();
    },
    search(){
      this.pageparm.currentPage = 1
      this.pageparm.pageSize = 10
      this.getdata()
    },
    getdata() {
      this.loading = true
      var params = {
        condition: {
          factoryId: this.userData.factoryId,
          technologyCode: this.form.technologyCode,
          technologyName: this.form.technologyName,
        },
        currentPage: this.pageparm.currentPage,
        pageSize: this.pageparm.pageSize,
      }
      technologyGetList(params).then(res => {
        if(res.code == 200){
          this.pageparm.total = res.data.total
          this.listData = res.data.list
        }else{
          this.$message.error('查询失败！')
        }
        this.loading = false
      })
      .catch(err => {
        this.loading = false
        this.$message.error(err)
      })
    },
    /**
     * 监听表格选中项变化事件
     */
    handleTblSelectionChange(val) {
      this.tblSelectionList = val;
    },
     // 分页插件事件
    callFather(parm) {
      this.pageparm.currentPage = parm.currentPage
      this.pageparm.pageSize = parm.pageSize
      this.getdata()
    },
    createProduct(){
      this.createProductPanVisible = true;
      this.mode = 'create'
    },
    productSave(options){
      if(options && options.type == 'save'){
        this.getdata()
      }
      this.createProductPanVisible =false;
      this.editRow = {}
    },
     viewImportLog(){
      this.isMain = !this.isMain;
    },
    goBack(){
      this.isMain = !this.isMain;
    },
    handleEdit(index,row){
      this.mode = 'edit'
      this.editRow = row
      this.createProductPanVisible = true
    },
    handleDelete(index,row){
      this.$confirm('确认删除工艺路线？删除后不可恢复', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
          // const pageLoading = this.openLoading(); //调用方法，打开loading遮罩层
          technologyDelete(row._id).then(res => {
              if (res.code == 200) {
                this.$message({
                  type: 'success',
                  message: res.msg
                })
                this.getdata()
              } else {
                this.$message({
                  type: 'error',
                  message: res.msg
                })
              }
              // pageLoading.close();
          }).catch(err => {
            // pageLoading.close();
            this.$message.error('删除失败，请稍后再试！')
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 批量操作
    handleCommand(options){
      var selection = this.$refs.tableData.selection
      if(selection.length==0){
        this.$message.warning('请先选择要批量操作的数据')
        return
      }
      if(options == 'delete'){
        this.$confirm('删除后数据无法恢复，确定删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var idList = selection.map(function(item){return item._id})
          var data = {
            idList:idList
          }
          technologyBatchDelete(idList).then(res => {
              if (res.code == 200) {
                this.$message({
                  type: 'success',
                  message: res.msg
                })
                this.getdata()
              } else {
                this.$message({
                  type: 'error',
                  message: res.msg
                })
              }
            })
          }).catch(err => {
              this.$message.error('删除失败，请稍后再试！')
            })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      }
    },
    formatProcess(options){
      if(options && options.length!=0){
        var res = options.map(function(item){
          if(item.type == 'process'){
            return item.processName
          }else{
            return item.technologyName
          }
        })
        if(res && res.length!=0){
          return res.join(',')
        }
      }
    }
  }
};
</script>
<style scoped>
.page-top {
  height: 30px;
  line-height: 30px;
}
.el-breadcrumb {
  line-height: 15px;
}
.page-row {
  /* background-color: #efefef; */
}
.page-row .el-tabs__nav-wrap::after {
  height: 0px;
}
.page-row .el-tabs__header {
  margin: 0px;
}

.user-search {
  margin-top: 20px;
}

.el-divider__text {
  padding: 0px 0px;
  font-size: 20px;
  cursor: pointer;
}
.tbl-pagination {
  text-align: right;
}
.tbl-btn {
  width: 100%;
  height: 40px;
  line-height: 40px;
}
.tbl-btn .tbl-btn-right {
  text-align: right;
}
.el-divider--horizontal {
  margin: 10px 0px;
}
.el-form-item {
  margin-bottom: 20px;
}
.search-row .half-width {
  width: calc(100% - 132px);
  margin-left: 8px;
}
.search-row .input-number {
  width: calc(50% - 5px);
}
</style>



// WEBPACK FOOTER //
// src/views/basicData/processRouting/ProcessRouting.vue